import { ReactNode } from 'react';

interface LanguageInitializerProps {
  children: ReactNode;
}

/**
 * Wrapper component that initializes language preference before rendering children
 * Must be rendered inside BrowserRouter to access navigation hooks
 */
export function LanguageInitializer({ children }: LanguageInitializerProps) {
  // Render immediately - language will update in background
  return <>{children}</>;
}
